import { type MaybeRefOrGetter, toValue } from 'vue';
import {
    pickColorConfig,
    type ColorInput,
    type ColorTint,
    isColorValueInput,
} from '../helpers/normalizeColor';
import { usePreconColorsOptions } from './usePreconColorsOptions';
import { Color } from '@kurkle/color';

let bodyStyles: CSSStyleDeclaration | null = null;

export function useColorResolver(): (
    input?: MaybeRefOrGetter<ColorInput | null | undefined>,
    tint?: MaybeRefOrGetter<ColorTint | null | undefined>
) => Color {
    const getStyles = () => {
        if (bodyStyles === null) {
            bodyStyles = getComputedStyle(document.body);
        }
        return bodyStyles;
    };

    const options = usePreconColorsOptions();

    return (input, tint) => {
        const resolvedInput = toValue(input) ?? options.value.fallbackColor;

        if (isColorValueInput(resolvedInput)) {
            const config = pickColorConfig(
                resolvedInput,
                options.value.colorConfigs
            );
            return new Color(
                getStyles().getPropertyValue(
                    `--${config.cssClassName}-${toValue(tint) ?? '500'}`
                )
            );
        } else {
            return new Color(resolvedInput);
        }
    };
}
